

    function F(){}

    /**
     * Do fn.apply on a constructor.
     */
    function ctorApply(ctor, args) {
        F.prototype = ctor.prototype;
        var instance = new F();
        ctor.apply(instance, args);
        return instance;
    }

    module.exports = ctorApply;





//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/ctorApply.js
// module id = 1600
// module chunks = 0 1 2